import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

const AuthGuard = () => {
  const { userDetail } = useAuth();
  if (userDetail !== undefined && !userDetail?.data?.accessToken)
    return <Navigate to="/" />;

  return <Outlet />;
};

export default AuthGuard;
